import CaladreTheme from "theme/Theme";
import sharedStyle from "../style";

const classes = {
  ...sharedStyle,
  profileDetails: {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    width: "90vw",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    boxShadow: 24,
    borderRadius: "12px",
    p: 3,
    [CaladreTheme.breakpoints.up("lg")]: {
      width: 450,
    },
    "& .MuiAvatar-root": {
      "& .MuiSvgIcon-root": {
        transition: "all 0.2s ease-in-out",
        "&:hover": {
          transform: "scale(1.1)",
        },
      },
      "&:not(.MuiAvatar-colorDefault)": {
        width: "90px",
        height: "90px",
      },
    },
    "& .MuiTypography-h5": {
      margin: "8px 0",
    },
    "& .MuiGrid-root": {
      [CaladreTheme.breakpoints.up("lg")]: {
        margin: "8px 0",
      },
    },
    "& .MuiGrid-item": {
      "& .MuiTypography-body1": {
        fontSize: "12px",
      },
    },
    "& .MuiListItem-root": {
      padding: 0,
      margin: "4px 0",
      "& .MuiListItemText-root .MuiTypography-root": {
        fontSize: "10px",
        fontFamily: "PoppinsBold, sans-serif",
        color: CaladreTheme.palette.primary.main,
      },
      "& .MuiListItemAvatar-root": {
        minWidth: 22,
      },
      "& .MuiAvatar-root ": {
        width: 22,
        height: 22,
        marginRight: CaladreTheme.spacing(0.8),
        backgroundColor: CaladreTheme.palette.primary.main,
        "& .MuiSvgIcon-root": {
          fontSize: "14px",
          transition: "all 0.2s ease-in-out",
          "&:hover": {
            transform: "scale(1.1)",
          },
        },
      },
    },
  },
  profilePreview: {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    width: "90vw",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    boxShadow: 24,
    borderRadius: "12px",
    p: 3,
    [CaladreTheme.breakpoints.up("lg")]: {
      width: "50%",
    },
    "& .MuiAvatar-root": {
      "& .MuiSvgIcon-root": {
        transition: "all 0.2s ease-in-out",
        "&:hover": {
          transform: "scale(1.1)",
        },
      },
      "&:not(.MuiAvatar-colorDefault)": {
        width: "90px",
        height: "90px",
      },
    },
    "& .MuiTypography-h5": {
      margin: "8px 0",
    },
    "& .MuiGrid-root": {
      [CaladreTheme.breakpoints.up("lg")]: {
        margin: "8px 0",
      },
    },
    "& .MuiGrid-item": {
      "& .MuiTypography-body1": {
        fontSize: "12px",
      },
    },
    "& .MuiListItem-root": {
      padding: 0,
      margin: "4px 0",
      "& .MuiListItemText-root .MuiTypography-root": {
        fontSize: "10px",
        fontFamily: "PoppinsBold, sans-serif",
        color: CaladreTheme.palette.primary.main,
      },
      "& .MuiListItemAvatar-root": {
        minWidth: 22,
      },
      "& .MuiAvatar-root ": {
        width: 22,
        height: 22,
        marginRight: CaladreTheme.spacing(0.8),
        backgroundColor: CaladreTheme.palette.primary.main,
        "& .MuiSvgIcon-root": {
          fontSize: "14px",
          transition: "all 0.2s ease-in-out",
          "&:hover": {
            transform: "scale(1.1)",
          },
        },
      },
    },
    "& .MuiImageList-root ": {
      gap: "10px !important",
      margin: 0,
      width: "100%",
      height: "100%",
      "& .MuiImageListItem-root:first-child img": {
        borderTopLeftRadius: "15px",
        borderTopRightRadius: "15px",
      },
      "& .MuiImageListItem-root:nth-of-type(2) img": {
        borderBottomLeftRadius: "15px",
      },
      "& .MuiImageListItem-root:last-child img": {
        borderBottomRightRadius: "15px",
      },
    },
  },
};
export default classes;
